import axios from 'axios';
import jsCookie from 'js-cookie'
import Vue from 'vue';
import {
  getLoginUrl
} from '@/hidream/utils/index'
class Http {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.NODE_ENV != 'development' ? `${window.location.origin}/serverApi` : process.env.VUE_APP_BASE_API,
      timeout: 15000,
      origin:true,
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true
    });

    // 请求拦截器
    this.axiosInstance.interceptors.request.use(
      (config) => {
        const vuid = jsCookie.get('vuid') ;
        const btoken = jsCookie.get('btoken') ;
        const phone = jsCookie.get('phone') ;
        if (vuid) {
          config.headers['X-Migu-Vuid'] = `${vuid}`;
        }
        if (vuid) {
          config.headers['X-Migu-Token'] = `${btoken}`;
        }
        if (phone) {
          config.headers['X-Phone'] = phone;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 响应拦截器
    this.axiosInstance.interceptors.response.use(
      (response) => {
        if (response.data.code === 8006 || response.data.code === 401) {
          // 弹出手机号验证码登录弹窗
          if (Vue.prototype.$showLoginDialog) {
            Vue.prototype.$showLoginDialog();
          } else {
            alert('请登录');
          }
          return Promise.reject(response.data);
        }
        return response.data;

      },
      (error) => {
        if (error.response && error.response.status === 401) {
          console.error('未授权，请登录');
          jsCookie.remove('ticket')

        } else if (error.response && error.response.status === 404) {
          console.error('not found');
        } else {
          return Promise.reject(error);
        }
      }
    );
  }

  get(url, params = {}, isLoading = true) {
    if (isLoading) {
      Vue.prototype.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
    }
    return this.axiosInstance.get(url, {
      params
    }).finally(() => {
      if (isLoading) {
        Vue.prototype.$toast.clear();
      }
    });
  }

  post(url, data = {}, isLoading = true) {
    if (isLoading) {
      Vue.prototype.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
    }
    return this.axiosInstance.post(url, data).finally(() => {
      if (isLoading) {
        Vue.prototype.$toast.clear();
      }
    });
  }

  put(url, data = {}, isLoading = true) {
    if (isLoading) {
      Vue.prototype.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
    }
    return this.axiosInstance.put(url, data).finally(() => {
      if (isLoading) {
        Vue.prototype.$toast.clear();
      }
    });
  }

  delete(url) {
    return this.axiosInstance.delete(url);
  }
}

export const http = new Http();
export async function refreshToken(token) {
  http.axiosInstance.defaults.headers.common['Refresh-Token'] = token || jsCookie.get('refresh_token')
  const response = await http.axiosInstance.get('/prod-api/user/apikey2token')
  if (response.code === 0) {
    jsCookie.set('ticket', response.result.token)
    return response.result.token
  }
}